import React from 'react';
import PropTypes from 'prop-types';
import InformativeModalLayout from '../InformativeModalLayout';
import SomethingChangedSvg from '../InformativeModalLayout/SomethingChangedSvg';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import { Modal } from 'wix-style-react';

export default function SettingsChangedModal({ isOpen, onRequestClose, clearCustomerSession, customer, phoneChange }) {
  const footer = (
    <BasicModalLayoutFooter
      okText="Refresh Phone Orders"
      displayCancelButton={false}
      onOkClick={() => {
        clearCustomerSession();
        phoneChange({ phone: customer.phone });
        onRequestClose();
      }}
    />
  );

  return (
    <Modal isOpen={isOpen}>
      <InformativeModalLayout
        dataHook="settings-changed-modal"
        title="Oops! something changed…"
        content="Something has changed during the order process, you’ll need to refresh in order to proceed."
        appendix="P.S we’ve got your back! customer info has been saved."
        onRequestClose={onRequestClose}
        footer={footer}
        illustration={<SomethingChangedSvg />}
      />
    </Modal>
  );
}

SettingsChangedModal.displayName = 'SettingsChangedModal';

SettingsChangedModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  clearCustomerSession: PropTypes.func,
  phone: PropTypes.string,
  customer: PropTypes.object,
  phoneChange: PropTypes.func,
};

SettingsChangedModal.defaultProps = {
  customer: {},
};
